import axios from 'axios'
import {
  Notification,
  MessageBox,
  Message
} from 'element-ui'
import store from '@/store'
// import {
//   getToken
// } from '@/utils/auth'
import errorCode from '@/utils/errorCode'
import tansParams from "@/utils/ruoyi";
import global from '@/utils/global.js'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  //baseURL: "http://172.16.1.140:8088",
  baseURL: global.apiUrl,
  // 超时
  timeout: 6000000
})
// request拦截器
service.interceptors.request.use(config => {
  // 是否需要设置 token
  var access_token=localStorage.access_token
  console.log(access_token)
  const isToken = (config.headers || {}).isToken === false
  if (access_token && !isToken) {
    config.headers['Authorization'] = 'Bearer ' + access_token // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers.common['token'] = access_token
  }
  if (config.method === 'get' && config.params) {
    // let url = config.url + '?' + tansParams(config.params);
    // url = url.slice(0, -1);
    // config.params = {};
    // config.url ="http://172.16.1.140:8088"+ url;
	let url = config.url + '?';
	for (const propName of Object.keys(config.params)) {
	  const value = config.params[propName];
	  var part = encodeURIComponent(propName) + "=";
	  if (value !== null && typeof(value) !== "undefined") {
	    if (typeof value === 'object') {
	      for (const key of Object.keys(value)) {
	        let params = propName + '[' + key + ']';
	        var subPart = encodeURIComponent(params) + "=";
	        url += subPart + encodeURIComponent(value[key]) + "&";
	      }
	    } else {
	      url += part + encodeURIComponent(value) + "&";
	    }
	  }
	}
	url = url.slice(0, -1);
	config.params = {};
	config.url = url;
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(
	response => {
		// VueCookies.set("JSESSIONID",localStorage.cook)
		
		
		// if (response.data.code == 200) {
		// 	setTimeout(r => {
		// 		sessionStorage.code = 200
		// 	}, 1000)
		// }
		if (response.data.code == 401) {
			sessionStorage.clear()
			sessionStorage.code = 401
			router.push("/")
		}
		return response
	},
	error => {
		// console.log(error.response.status);
		if (error.response.status == 401) {
			ElementUI.Message.warning("无权限")
			sessionStorage.clear()
			router.push("/")
		}
		return error;
	}
)

export default service
